import { useQueryClient, useMutation } from '@tanstack/react-query';
import { deleteSelected } from "../orgPanelApiCalls";
import { key as deleteSelectedKey } from "../queries/useDeleteSelectedQuery";
import { key as structuralHierarchyKey } from "../queries/useStructuralHierachyQuery";

const useDeleteSelectedMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (variables) => {
            const accountIdsToRemove = variables.map((v) => parseInt(v));
            const data = await deleteSelected(variables);
            return { ...data, accountIdsToRemove };
        },
        onSuccess: (data) => {
            if (data.accountIdsToRemove !== null) {
                queryClient.setQueryData([structuralHierarchyKey], (previousData) => previousData.filter(
                    (item) => !data.accountIdsToRemove.includes(item.accountId)
                ));
            }
            queryClient.setQueryData([deleteSelectedKey], () => {
                return data;
            });
        },
    })
}

export { useDeleteSelectedMutation };